app.controller('fillVisitDataController', ['$scope', '$state', '$mdToast', '$mdDialog', '$translate', 'objectHelper', 'applicationModel', 'userModel', 'visitModel', 'visitCardModel', 'doctorModel',
    function ($scope, $state, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, userModel, visitModel, visitCardModel, doctorModel) {

        function setProperColor(element, office) {
            if (office && office.id > 0) {
                element[0].style.setProperty('background-color', office.color, 'important');
            } else {
                element[0].style.setProperty('background-color', '');
            }
        }

        function getProperCriteria(criteria) {
            var localCriteria = angular.copy(criteria);
            if(userModel.currentUser.userType === 'DOCTOR') {
                localCriteria.doctorId = userModel.currentUser.id;
            }
            if(userModel.currentUser.userType === 'MEDICAL_OFFICE') {
                localCriteria.clinicId = userModel.currentUser.clinicId;
            }
            return localCriteria;
        }

        function selectTab(office) {
            Object.keys($scope.activeOfficeTab).forEach(function(prop) {
                $scope.activeOfficeTab[prop] = false;
            });

            $scope.activeOfficeTab[office.name] = true;

            var mdInkBar = $('md-tabs md-ink-bar');
            setProperColor(mdInkBar, office);

            var criteria = new VisitDataGridCriteria();
            criteria.visitStatuses = [Enum.VISIT_STATUS.SUSPENDED, Enum.VISIT_STATUS.IN_PROGRESS];
            criteria = getProperCriteria(criteria);
            if(office.id) {
                $scope.officeId = office.id;
                criteria.officeId = office.id;
            } else {
                $scope.officeId = null;
            }

            visitModel.getDataPage(criteria);
        }

        function findOfficeAndFilterList(officeName) {
            var mappedOfficeNames = $scope.officeTabs.map(function(element) { return element.name });
            var selectedOffice = mappedOfficeNames.indexOf(officeName);
            selectTab($scope.officeTabs[selectedOffice]);
        }

        function setData() {
            $scope.criteria = new VisitDataGridCriteria();
            $scope.criteria = getProperCriteria($scope.criteria);
            $scope.criteria.visitStatuses = [Enum.VISIT_STATUS.SUSPENDED, Enum.VISIT_STATUS.IN_PROGRESS];
            $scope.criteria.sortColumns = [new EsDataGridSort('date', true)];


            $scope.buttons = [];
            $scope.presentDate = new Date().setHours(0,0,0,0);
            $scope.visitListWithLabels = [];
            $scope.doctor = null;
            $scope.currentTab = 'wszystko';

            $scope.rowsPerSheet = 20;
            $scope.currentPage = 1;

            $scope.noSearchResult = false;

            $scope.officeTabs = [{
                name: 'wszystko'
            }];

            $scope.offices = [];

            $scope.activeOfficeTab = {
                all: true
            };

        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });

            $scope.$watch('currentTab', function(newVal) {
                if($scope.officeTabs.length > 1) {
                    findOfficeAndFilterList(newVal)
                }
            });

            $scope.$on(Event.VISIT.GET_DATA_PAGE.SUCCESS, function(event, dataPage, pageNumber) {
                if(!dataPage.data.length) {
                    $scope.noSearchResult = true;
                    return false;
                }
                if(dataPage.data.length && $scope.noSearchResult) {
                    $scope.noSearchResult = false;
                }
                $scope.visits = dataPage.data;
                $scope.numberOfPages = dataPage.numberOfPages;
                $scope.currentPage = pageNumber + 1;
                $scope.clinicsWithVisits = [];

                $scope.visitListWithLabels = [];
                dataPage.data.forEach(function(element, index) {
                    if(index === 0) {
                        $scope.visitListWithLabels.push({ type: 'label', data: { text: element.office.name, color: element.office.color }});
                    } else {
                        if(element.office && dataPage.data[index-1].office && (dataPage.data[index-1].office.id != element.office.id)) {
                            $scope.visitListWithLabels.push({ type: 'label', data: { text: element.office.name, color: element.office.color } });
                        }
                    }

                    $scope.visitListWithLabels.push({ type: 'visit', data: element });
                });

                if($scope.officeTabs.length === 1) {
                    _.remove($scope.offices, function (office) {
                        for (var i = 0; i < dataPage.data.length; i++) {
                            if (!office.id || (dataPage.data[i].office && dataPage.data[i].office.id === office.id)) {
                                $scope.officeTabs.push(dataPage.data[i].office);
                                return false;
                            }
                        }
                        return true;
                    });
                }
            });

            $scope.$on(Event.VISIT.COMPLETE.SUCCESS, function() {
                if($scope.officeId) {
                    $scope.criteria.officeId = $scope.officeId;
                }
                visitModel.getDataPage($scope.criteria);
            });

            $scope.$on(Event.DOCTOR.GET_BY_ID.SUCCESS, function(event, doctor) {
                $scope.doctor = doctor;
                doctor.offices.forEach(function(element) {
                    $scope.activeOfficeTab[element.name] = false;
                    $scope.offices.push(element)
                });

                visitModel.getDataPage($scope.criteria);
            })
        }

        function setActions() {

            $scope.fillVisitData = function (visit) {
                if(visit.visitStatus === Enum.VISIT_STATUS.IN_PROGRESS || visit.visitStatus === Enum.VISIT_STATUS.SUSPENDED) {
                    $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD, { patientId: visit.patient.id, visitId: visit.id });
                }
            };

            $scope.closeVisit = function(visit) {
                visitCardModel.getById(visit.visitCard.id);

                var successDisabler = $scope.$on(Event.VISIT_CARD.GET_BY_ID.SUCCESS, function (event, visitCard) {
                    successDisabler();
                    errorDisabler();

                    var visitToClose = visit;
                    visitToClose.visitCard = visitCard;

                    visitModel.complete(visitToClose);
                });

                var errorDisabler = $scope.$on(Event.VISIT_CARD.GET_BY_ID.SUCCESS, function (event, visitCard) {
                    successDisabler();
                    errorDisabler();
                });
            };

            $scope.criteriaChanged = function() {
                if($scope.officeId) {
                    $scope.criteria.officeId = $scope.officeId;
                }
                visitModel.getDataPage($scope.criteria);
            };

            $scope.checkForTodayDate = function(date) {
                return $scope.presentDate.getTime() === date.getTime();
            };

            $scope.selectOfficeTab = function(tab) {
                $scope.currentTab = tab.name;
            };

            $scope.getTotal = function() {
                return $scope.rowsPerSheet * $scope.numberOfPages;
            };

            $scope.criteriaChanged = function () {
                if($scope.rowsPerSheet != $scope.criteria.rowsPerSheet) {
                    $scope.criteria.rowsPerSheet = $scope.rowsPerSheet;
                    $scope.currentPage = 1;
                }
                $scope.criteria.pageNumber = $scope.currentPage - 1;

                visitModel.getDataPage($scope.criteria);
            };

        }

        function configureInterface() {

        }

        function initialize() {
            applicationModel.viewReady = true;
            if(userModel.getCurrentContextDoctorId()) {
                doctorModel.getById(userModel.getCurrentContextDoctorId());
            } else {
                visitModel.getDataPage($scope.criteria);
            }
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
